import React from 'react'
import url from 'front-end-core/core/url'
import { ACCOUNT } from 'constants/controllers'
import { ACCOUNT_PREFERENCES } from 'constants/account-menu'
import EmailIcon from '@material-ui/icons/Email'

const Title = ({ short }) => (
  <section className='w-100 ph6 pt4 pb5 flex justify-between bb-thick b--light-sea-green-2 items-center'>
    <ToggleText display={!short} />
    <PreferenceLink />
  </section>
)

const PreferenceLink = () => {
  if (!ACCOUNT_PREFERENCES.visible) {
    return null
  }

  return (
    <a
      className='cadet-blue f7 flex items-center no-underline hover-underline'
      href={url(ACCOUNT, { view: ACCOUNT_PREFERENCES.view })}
      data-event-category='Current Awareness'
      data-event-action='Go to account preferences'
    >
      <span className='mr4'>
        Update your email preferences
      </span>
      <EmailIcon />
    </a>
  )
}

const ToggleText = ({ display }) => !display
  ? null
  : (
    <span className='b f3'>
      News
    </span>
    )

export default Title
